export const BRAND = {
  name: "WHY NOT HEALTHY FOODS",
  short: "WHY NOT",
  tagline: "healthy · kids love · tasty at affordable",
  city: "Hyderabad, Telangana, India",
  coords: "17.3850° N, 78.4867° E",
  domain: "https://www.whynothealthyfoods.com",
};

// PLACEHOLDERS — replace with the company's real contact details before going live.
export const CONTACT = {
  email: "hello@whynothealthyfoods.com",
  phoneDisplay: "+91 XXXXX XXXXX",
  whatsappNumber: "919876543210",
  address: "Hyderabad, Telangana, India",
  addressNote: "Registered office address to be added",
  hours: "Export desk — Monday to Saturday · IST (GMT+5:30)",
};

export const WA_LINK = (msg) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    msg || "Hello WHY NOT HEALTHY FOODS — I'd like to discuss an export enquiry."
  )}`;

// Paste your Zoho CRM form embed URL here (e.g. https://forms.zohopublic.in/...) to
// replace the native quote form in one step — no other change is needed.
export const ZOHO_EMBED_URL = null;

export const LEAD_SOURCE = "Website RFQ - B2B Portal";

export const PAYMENT_TERMS = "A 50% advance payment is mandatory. The remaining 50% must be paid before shipment. We dispatch only after receiving 100% payment.";

export const CONSENT_TEXT =
  "I consent to WHY NOT HEALTHY FOODS storing and processing the details I submit — including my name, company and contact information — solely to prepare an export quotation and send related trade communications. I can request removal at any time.";

export const NAV = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Catalogue", href: "/products" },
  { name: "Export Process", href: "/export-process" },
  { name: "Packaging", href: "/packaging-shipping" },
  { name: "Compliance", href: "/certifications" },
  { name: "FAQ", href: "/faq" },
  { name: "Contact", href: "/contact" },
];

export const CATEGORIES = [
  {
    id: "millets",
    name: "Millets & Ancient Grains",
    blurb: "Sorghum, pearl millet, finger millet, foxtail millet — the climate-smart cereals global buyers are asking for.",
  },
  {
    id: "pulses",
    name: "Pulses & Lentils",
    blurb: "Cleaned, graded machine-dressed pulses from India's Deccan heartland, packed to buyer specification.",
  },
  {
    id: "seeds",
    name: "Seeds & Oilseeds",
    blurb: "Purity-graded sesame and other oilseeds for bakeries, tahini pressers and oil houses.",
  },
  {
    id: "superfoods",
    name: "Superfood Powders",
    blurb: "Green superfood powders and value-added healthy ingredients for blends and functional foods.",
  },
];

const U = (id) => `https://images.unsplash.com/${id}?q=85&w=1600&auto=format&fit=crop`;

export const PRODUCTS = [
  {
    slug: "sorghum-jowar",
    name: "Sorghum (Jowar)",
    cat: "Millets & Ancient Grains",
    tagline: "The climate-proof cereal for gluten-free markets",
    img: U("photo-1724418020207-144b3ba54d2d"),
    blurb: [
      "Sorghum is one of India's most resilient cereal crops — grown across the Deccan plateau and prized worldwide as a naturally gluten-free ancient grain. It mills into flour for bakery and snack lines, pops like corn, and cooks whole as a nutritious staple.",
      "We supply sorghum cleaned and graded to buyer specification, with specification sheets, quality parameters and certificates of analysis shared on request before each shipment.",
    ],
  },
  {
    slug: "pearl-millet-bajra",
    name: "Pearl Millet (Bajra)",
    cat: "Millets & Ancient Grains",
    tagline: "Iron-rich staple for flours, porridges and snacks",
    img: U("photo-1682944625832-fd710e15b190"),
    blurb: [
      "Pearl millet is the most widely grown millet in India and a rising star in health-food retail — high in dietary fibre and iron, naturally gluten-free, and increasingly used in multigrain flours, breakfast porridges and baked snacks.",
      "Bulk export supply is arranged from established procurement networks, with grading, packing and documentation tailored to the buyer's market.",
    ],
  },
  {
    slug: "finger-millet-ragi",
    name: "Finger Millet (Ragi)",
    cat: "Millets & Ancient Grains",
    tagline: "Calcium-dense supergrain for health foods and infant blends",
    img: U("photo-1608797178894-bf7c596932da"),
    blurb: [
      "Finger millet — ragi — is celebrated as one of the most nutritious of all millets, remarkably rich in calcium and polyphenols. Global demand is surging from health-food brands, cereal makers and infant-nutrition formulators.",
      "Tell us the grade, purity and packing you need; we respond with availability, specification and a formal quotation.",
    ],
  },
  {
    slug: "foxtail-millet",
    name: "Foxtail Millet",
    cat: "Millets & Ancient Grains",
    tagline: "Low-GI favourite for upmarket retail and food service",
    img: U("photo-1508748169069-82590c9f26e6"),
    blurb: [
      "Foxtail millet cooks like couscous, carries a low glycaemic profile and has become a fixture in premium retail wellness aisles. It is sold as whole grain, semolina or flour.",
      "We ship foxtail millet in bulk bags or retail-ready private-label packs, with samples arranged before contract.",
    ],
  },
  {
    slug: "red-gram-toor-dal",
    name: "Red Gram (Toor Dal)",
    cat: "Pulses & Lentils",
    tagline: "The everyday pulse, cleaned and graded for export",
    img: U("photo-1621956838481-f8f616950454"),
    blurb: [
      "Red gram — pigeon pea — is the backbone of India's dal trade. Export buyers know it for consistent cooking quality and rich protein content; importers demand uniformly clean, machine-dressed product.",
      "We source from mandi networks across Telangana and neighbouring states, supplying polished or unpolished lots to buyer specification.",
    ],
  },
  {
    slug: "kabuli-chickpeas",
    name: "Kabuli Chickpeas",
    cat: "Pulses & Lentils",
    tagline: "Large-seeded chickpeas for hummus, flour and canning lines",
    img: U("photo-1641913712124-a58d267b6997"),
    blurb: [
      "Kabuli chickpeas — large, cream-white seeds — feed the world's hummus, besan flour and canning industries. India is both a major producer and a trusted origin for count-based export grades.",
      "Counts, purity and moisture are confirmed against buyer requirement; specification sheets and lab parameters are shared on request.",
    ],
  },
  {
    slug: "hulled-sesame-seeds",
    name: "Hulled Sesame Seeds",
    cat: "Seeds & Oilseeds",
    tagline: "Purity-graded sesame for bakeries and tahini pressers",
    img: "https://images.pexels.com/photos/8951049/pexels-photo-8951049.jpeg?auto=compress&cs=tinysrgb&w=1600",
    blurb: [
      "India is a benchmark origin for natural and hulled sesame. Export-grade sesame is defined by purity, cleanliness and colour — parameters that decide its place on bakery lines and in tahini pressing.",
      "We supply natural and hulled sesame with quality parameters and certificates shared on request, in bulk export bags or container liners.",
    ],
  },
  {
    slug: "moringa-leaf-powder",
    name: "Moringa Leaf Powder",
    cat: "Superfood Powders",
    tagline: "Green superfood powder for blends and functional foods",
    img: U("photo-1565802700474-1c8b57596859"),
    blurb: [
      "Moringa oleifera leaf powder is one of India's most talked-about green superfoods — used in smoothie blends, supplements and functional-food formulations worldwide.",
      "Supply is arranged in food-grade retail packs or bulk cartons, with product specifications and test documentation shared on request.",
    ],
  },
];

export const productBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const STEPS = [
  { n: "01", t: "RFQ & specification", d: "You share the product, quantity, destination port and packing requirement. We respond with availability and a formal quotation — every RFQ gets a personal reply from the export desk." },
  { n: "02", t: "Samples & lab reports", d: "Where needed, samples are couriered for your evaluation. Quality parameters and certificates of analysis are shared on request before you commit." },
  { n: "03", t: "Contract & payment terms", d: `Price, Incoterm (FOB / CIF / CFR) and delivery schedule are confirmed in the sales contract. ${PAYMENT_TERMS}` },
  { n: "04", t: "Packing & palletization", d: "Cargo is cleaned, graded and packed to the agreed format — bulk export bags, container liners or retail-ready private label." },
  { n: "05", t: "Port clearance & inspection", d: "Consignment moves to the gateway port; export customs clearance and consignment-specific inspections and certificates are completed." },
  { n: "06", t: "Documents & tracking", d: "Bill of lading and the full document set are issued and shared. You receive a tracking reference to follow the consignment live on our site." },
];

export const FAQS = [
  { q: "What is your minimum order quantity (MOQ)?", a: "MOQs vary by product, grade and packing format. Share your requirement and destination port through the quote form — we confirm MOQ and current availability with the quotation itself." },
  { q: "Do you provide samples?", a: "Yes, samples can be arranged for serious buyers. Courier charges and terms are agreed case by case — request samples through the quote form or WhatsApp with your requirement." },
  { q: "How is pricing quoted?", a: "Prices are quoted per product, specification and Incoterm — FOB, CIF or CFR. Currency, validity and price-break quantities are stated clearly in the quotation." },
  { q: "Which payment terms do you accept?", a: PAYMENT_TERMS },
  { q: "What are typical lead times?", a: "Lead time depends on the product, season, packing format and vessel connection. The committed production and shipping schedule is confirmed per order in the contract." },
  { q: "Do you support domestic white labelling and private labelling?", a: "Yes. Submit a domestic white-label or private-label enquiry for any product, or request an export quote. Share your brand, quantity, packing and delivery requirements so we can confirm the options and quotation." },
  { q: "Which documents come with each consignment?", a: "The standard export set — commercial invoice, packing list, certificate of origin, phytosanitary certificate and bill of lading — with fumigation and other certificates as applicable. Certificates of analysis are shared on request." },
  { q: "How do I track my shipment?", a: "Once your consignment is booked, you receive a tracking reference. Enter it on our Track Shipment page to see a live status timeline from contract to destination port." },
  { q: "Do you store my enquiry details?", a: "Only to respond to your request. Enquiry details are stored solely to prepare your quotation and send related trade communications — never sold or shared for marketing. You can ask us to remove your data at any time." },
];
